import { axiosSSO } from 'config';

export const fetchFeatureFlags = () => axiosSSO('/feature-flags');